import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";
import { Exception } from "@microsoft/applicationinsights-web";

const myBswHealthBffBaseUrl = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbff : '';
const functionsKey = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbfffunctionskey : '';


export const getMembershipData = (token) => {
    const url = tools.buildUrl(myBswHealthBffBaseUrl, '/v1/profile');
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };

    const start = new Date();

    return tools.superFetch(url, params, start, "MBHWeb.Api.MyBSWBFF.GetProfile");
    //return fetch(url, params).then(response => {
    //    logAPI("MBHWeb.Api.MyBSWBFF.GetProfile", start, url);
    //    //return Promise.reject({status: "failed", message:"Massive failure!!"});
    //    var oRet = JSON.parse("");
    //    //throw "Massive failure!!";

    //    if (response.status >= 200 && response.status < 300) {
    //        return Promise.resolve(response.json());
    //    } else {
    //        return Promise.reject(response);
    //    }
    //}).catch(err => {
    //    debugger;
    //    logAPI("MBHWeb.Api.MyBSWBFF.GetProfile.Failure", start, url, err);
    //    return Promise.reject(err);
    //});

};



export const refreshProfile = (token) => {
    //v1/login
    const url = tools.buildUrl(myBswHealthBffBaseUrl, '/v1/login');
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };

    const start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.MyBSWBFF.RefreshProfile", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);   // no json return, no return at all
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.MyBSWBFF.RefreshProfile.Failure", start, url, err);
        return Promise.reject(err);
    });

}


export const setMarketingEmailOptIn = (token, optInData) => {
    const url = tools.buildUrl(myBswHealthBffBaseUrl, '/v1/emailoptin');

    const params = {
        method: "POST",
        body: JSON.stringify(optInData),
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.MyBSWBFF.MarketingEmailOptIn", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.MyBSWBFF.MarketingEmailOptIn.Failure", start, url, err); return Promise.reject(err); });
};

export const setScrubbingInEmailOptIn = (token, optInData) => {
    const url = tools.buildUrl(myBswHealthBffBaseUrl, '/v1/emailscrubbinginsubscribe');

    const params = {
        method: "POST",
        body: JSON.stringify(optInData),
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json",
            "x-functions-key": functionsKey,
        },
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.MyBSWBFF.ScrubbingInEmailOptIn", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.MyBSWBFF.ScrubbingInEmailOptIn.Failure", start, url, err); return Promise.reject(err); });
};
